import type {FieldDependents} from "./mate/mate-types";

/**
 * Written field → fields the server changes with it. Writing a field marks these stale too, so they
 * reload. A foreign key also marks its relation (`assigneeId` → `assignee`).
 */
export const fieldDependents: FieldDependents = {
  card: {
    content: [
      "title",
      "tags",
      "masterTags",
      "mentionedUsers",
      "checkboxStats",
      "checkboxInfo",
      "meta",
      "status",
      "visibility",
      "lastUpdatedAt",
    ],
    masterTags: ["content", "tags", "status", "visibility", "lastUpdatedAt"],
    deckId: ["tags", "masterTags", "milestoneId", "status", "visibility", "lastUpdatedAt"],
    assigneeId: ["status", "visibility"],
    priority: ["status", "visibility", "lastUpdatedAt"],
    effort: ["status", "visibility", "lastUpdatedAt"],
    status: ["visibility", "lastUpdatedAt", "assigneeId", "creatorId"],
    visibility: ["status", "lastUpdatedAt"],
  },
  workflowItem: {
    content: [
      "title",
      "tags",
      "masterTags",
      "mentionedUsers",
      "checkboxStats",
      "checkboxInfo",
      "visibility",
      "lastUpdatedAt",
    ],
    masterTags: ["content", "tags", "visibility", "lastUpdatedAt"],
    deckId: ["visibility"],
    targetDeckId: ["lastUpdatedAt"],
    assigneeId: ["visibility"],
    priority: ["visibility", "lastUpdatedAt"],
    effort: ["visibility", "lastUpdatedAt"],
    visibility: ["lastUpdatedAt"],
  },
  resolvable: {isClosed: ["closedAt", "reopenedAt", "closedBy", "reopenedBy"]},
  resolvableEntry: {content: ["lastChangedAt", "version"]},
  attachment: {content: ["title"]},
};
